import videojs from 'video.js';

import type PlayerError from '@src/errors/PlayerError';

const hwvpLogger = videojs.log.createLogger('HWVP');

const errorWithCause = (err?: PlayerError | Error) => {
  const cause = typeof err === 'object' ? (err as PlayerError).cause : null;

  if (cause) {
    hwvpLogger.error(err);
    console.group(`Cause | ${err?.name}: ${err?.message}`);
    hwvpLogger.error(cause);
    console.groupEnd();
  } else {
    hwvpLogger.error(err);
  }
};

const logger = new Proxy<typeof hwvpLogger & { log(...args: any[]): void }>(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  hwvpLogger,
  {
    get(target, prop /*, receiver */) {
      if (['log'].includes(prop as string)) {
        return hwvpLogger;
      }

      if ((prop as string) === 'error') {
        return errorWithCause;
      }
      /*
      if ((prop as string) === 'error') {
        return (err?: PlayerError | Error) => {
          const cause =
            typeof err === 'object' ? (err as PlayerError).cause : null;

          if (cause) {
            target.error(err);
            console.group(`Cause | ${err?.name}: ${err?.message}`);
            target.error(cause);
            console.groupEnd();
          } else {
            target.error(err);
          }
        };
      }
      */

      return target[prop as keyof typeof hwvpLogger];
    },
  }
);

export default logger;
